import React, { Component } from 'react';
import SuperTreeview from 'react-super-treeview';
import MembersTreeViewNodeHelper from '../utilities/MembersTreeViewNodeHelper';
import { IsThisConnectionPowerBi } from '../utilities/helperFunctions';
import { getConnectionMembers, getConnectionSegments, getSegmentMembers, getMembersWithinSegment } from '../../actions/databaseActions';
import { DoTheseSelectionsHaveMultiSegments } from './helpers/SelectionsHelper'

export default class DimensionMemberSelector extends Component {
    //#region React Hooks
    constructor(props) {
        super(props);
        this.state = {
            "className": "",
            "iterator": 1,
            "membersPage": 0,
            "multiSelect": true,
            "chartId": -1,
            "connectionId": -1,
            "allConnectionIds": [],
            "dataSource": "",
            "dimensionAlias": "",
            "connectionName": "",
            "treeData": [],
            "selections": [],
            "searchTerm": "",
            "quickPicksTag": {},
            "globals": []
        };
    }
    componentDidMount() {
        let multiSelect = true
        let connectionId = -1
        let allConnectionIds = []
        let chartId = -1
        let dataSource = ""
        let dimensionAlias = ""
        let connectionName = ""
        let className = ""
        let selections = []
        let addedMultiSegmentSelections = []
        let quickPicksTag = {}
        let globals = []

        // Read in the props passed in from the parent
        if (this.props.multiSelect !== undefined) { multiSelect = this.props.multiSelect; }
        if (this.props.dimensionAlias !== undefined) { dimensionAlias = this.props.dimensionAlias; }
        if (this.props.chartId !== undefined) { chartId = this.props.chartId; }
        if (this.props.connectionId !== undefined) { connectionId = this.props.connectionId; }
        if (this.props.allConnectionIds !== undefined) { allConnectionIds = this.props.allConnectionIds; }
        if (this.props.dataSource !== undefined) { dataSource = this.props.dataSource; }
        if (this.props.connectionName !== undefined) { connectionName = this.props.connectionName; }
        if (this.props.className !== undefined) { className = this.props.className; }
        if (this.props.selections !== undefined) { selections = this.props.selections; }
        if (this.props.quickPicksTag) { quickPicksTag = this.props.quickPicksTag; }
        if (this.props.globals) { globals = this.props.globals }

        let treeData = this.setInitialTreeView(selections, addedMultiSegmentSelections, quickPicksTag, dataSource, connectionName, globals, dimensionAlias)

        this.setState({ multiSelect, chartId, connectionId, allConnectionIds, dataSource, dimensionAlias, connectionName, className, selections, quickPicksTag, globals, treeData })
    }
    componentDidUpdate(prevProps) {
        let newMultiLevelSegmentAdded = false;
        if (prevProps.addedNumber !== undefined && this.props.addedNumber !== undefined && prevProps.addedNumber !== this.props.addedNumber) {
            newMultiLevelSegmentAdded = true;
        }

        // Different chart change or we are swapping the dimensions or we added a new multi segement
        if (prevProps.chartId !== this.props.chartId ||
            prevProps.dimensionAlias !== this.props.dimensionAlias ||
            newMultiLevelSegmentAdded ||
            (prevProps.allConnectionIds && prevProps.allConnectionIds.length !== this.props.allConnectionIds.length)) {
            let multiSelect = true
            let connectionId = -1
            let allConnectionIds = []
            let chartId = -1
            let dataSource = ""
            let dimensionAlias = ""
            let connectionName = ""
            let className = ""
            let selections = []
            let addedMultiSegmentSelections = []
            let quickPicksTag = {}
            let globals = []

            // Read in the props passed in from the parent
            if (this.props.multiSelect !== undefined) { multiSelect = this.props.multiSelect; }
            if (this.props.dimensionAlias !== undefined) { dimensionAlias = this.props.dimensionAlias; }
            if (this.props.chartId !== undefined) { chartId = this.props.chartId; }
            if (this.props.connectionId !== undefined) { connectionId = this.props.connectionId; }
            if (this.props.allConnectionIds !== undefined) { allConnectionIds = this.props.allConnectionIds; }
            if (this.props.dataSource !== undefined) { dataSource = this.props.dataSource; }
            if (this.props.connectionName !== undefined) { connectionName = this.props.connectionName; }
            if (this.props.className !== undefined) { className = this.props.className; }
            if (this.props.selections !== undefined) { selections = this.props.selections; }
            if (this.props.addedMultiSegmentSelections) { addedMultiSegmentSelections = this.props.addedMultiSegmentSelections; }
            if (this.props.quickPicksTag) { quickPicksTag = this.props.quickPicksTag; }
            if (this.props.globals) { globals = this.props.globals }

            let treeData = this.setInitialTreeView(selections, addedMultiSegmentSelections, quickPicksTag, dataSource, connectionName, globals, dimensionAlias)

            this.setState({ multiSelect, chartId, connectionId, allConnectionIds, dataSource, dimensionAlias, connectionName, className, selections, quickPicksTag, treeData });
        } else if (prevProps.selections.length !== this.props.selections.length) {
            let selections = this.props.selections;
            let treeData = this.state.treeData;

            this.recursivelyLookupNewChecked(treeData, selections);

            let copiedObject = JSON.parse(JSON.stringify(treeData));
            /*
             * I am legit not happy about this DISGUSTING hack for this treeview, but I clearly cannot update the tree data
             * externally unless I add an object at the top level.
             * 
             * So this way, now a user can edit the checked selections externally and pass them back into the tree view.
            */
            copiedObject.push({
                "id": "updatedPushNode",
                "name": "Updated",
                "isExpanded": false,
                "isChecked": false,
                "isExpandable": false,
                "isCheckable": false,
                "value": {},
                "lastChanged": null,
                "children": []
            });

            this.setState({ selections, treeData: copiedObject });
        }
    }
    render() {
        return <div className={this.state.className}>
            <input className="myInput" type="text" placeholder="Search For Member" value={this.state.searchTerm} onChange={this.handleSearchTermChange} />
            <SuperTreeview
                data={this.state.treeData}
                isDeletable={(node, depth) => false}
                onUpdateCb={(updatedData) => this.updateTreeData(updatedData, this.state.multiSelect)}
                getStyleClassCb={(node, depth) => {
                    let finalCssClass = " ";

                    if (node.value.caption !== undefined && this.state.searchTerm !== "" && node.id !== "expandToLoadMore") {
                        if (node.value.caption.toLowerCase().indexOf(this.state.searchTerm.toLowerCase()) === -1) {
                            finalCssClass = " hide";
                        }
                    }

                    if (node.id === "updatedPushNode") {
                        finalCssClass = " hide";
                    }

                    return finalCssClass;
                }}
                onCheckToggleCb={(arrayOfNodes) => {
                    let selections = this.state.selections;

                    arrayOfNodes.forEach(node => {
                        if (node.isChecked) {
                            node.lastChanged = new Date();

                            // Add this new node to the selection
                            if (this.state.multiSelect === false) selections = [];
                            let newSelection = this.getSelectionDataFromNodeValue(node.value);
                            selections.push(newSelection);
                        } else {
                            node.lastChanged = null;

                            // Remove this node from the selection
                            selections = this.removeSpecificItemFromCollection(node.value, selections);
                        }
                    });

                    // Fire the "bubble up" method to talk to the parent component
                    if (this.props.onSelectionChange) { this.props.onSelectionChange(selections, this.state.dimensionAlias); }
                    this.setState({ selections });
                }}
                isExpandable={(node) => node.isExpandable}
                isCheckable={(node) => node.isCheckable}
                onExpandToggleCb={async (node, depth) => {
                    if (node.children === null) {
                        if (node.id === -1) {
                            // Highest Level - Members - Get All Members
                            node.isChildrenLoading = true;
                            let currentData = await this.loadAdditionalMembersAsync(node);
                            this.setState({ treeData: currentData });
                        } else if (node.id === -2) {
                            // Highest Level - Segments - Get All Segments
                            node.isChildrenLoading = true;
                            let currentData = await this.loadSegmentsAsync(node);
                            this.setState({ treeData: currentData });
                        } else if (node.value.valueAlias && node.value.segment === true && node.value.segmentNames === true) {
                            // Segment Expanded - Get Members Within Segment
                            node.isChildrenLoading = true;
                            let currentData = await this.loadSegmentMembersAsync(node);
                            this.setState({ treeData: currentData });
                        } else if (node.value.valueAlias !== null && node.value.segment === true && node.value.segmentMembers === true) {
                            // Segement Member Expanded - Get Lowest Level Members of Segment
                            node.isChildrenLoading = true;
                            let currentData = await this.loadSegmentLowerLevelMembers(node);
                            this.setState({ treeData: currentData });
                        } else if (node.value.nodeSegments !== undefined && node.value.segmentLevel !== undefined) {
                            // Multi Segment Expanded
                            node.isChildrenLoading = true;
                            let currentData = await this.loadFirstMultiSegmentLayer(node);
                            this.setState({ treeData: currentData });
                        }
                    }

                    if (node.id === "expandToLoadMore") {
                        node.isChildrenLoading = true;
                        let currentData = await this.loadAdditionalMembersAsync(node);
                        this.setState({ treeData: currentData });
                    }
                }}
            />
        </div>;
    }
    //#endregion

    //#region Calling the API to fill in the treeview
    loadAdditionalMembersAsync = async (nodeToExpand) => {
        // Get variables from state
        let iterator = this.state.iterator;
        let connectionId = this.state.connectionId;
        let allConnectionIds = this.state.allConnectionIds;
        let alias = this.state.dataSource;
        let dimensionName = this.state.dimensionAlias;
        let connectionName = this.state.connectionName;
        let data = this.state.treeData;
        let selections = this.state.selections;
        let membersPage = this.state.membersPage;
        let searchTerm = this.state.searchTerm;

        // Special Case - If the expand more members node is clicked, lets just concatenate them to the node id = -1
        let selectedParentNode = nodeToExpand;
        if (nodeToExpand.id === "expandToLoadMore") {
            selectedParentNode = { id: -1 };

            // Remove the "expandToLoadMore" checkbox we put in place
            data[0].children = data[0].children.splice(0, data[0].children.length - 1);
        }

        // Call the API Endpoint to get the dimension members
        let response = await getConnectionMembers(connectionId, allConnectionIds, alias, dimensionName, searchTerm, this.getAllCurrentlyLoadedItems(data), connectionName);

        // Process Response
        let members = [];
        let dimension = response.dimension;

        // Build the new nodes
        dimension.members.forEach(d => {
            members.push(
                MembersTreeViewNodeHelper.GetIndividualMemberTreeViewNode(
                    d,
                    dimension,
                    iterator,
                    MembersTreeViewNodeHelper.IsThisMemberDimensionPartOfTheSelections(selections, d)
                )
            );

            iterator++;
        });

        // If less than 20 members come back, we can assume we have reached the end of the paging
        if (members.length < 20) {
            membersPage = -1;
        } else {
            membersPage = membersPage + 1;
            members.push(MembersTreeViewNodeHelper.GetLoadAdditionalMembersNode());
        }

        // Set the new data
        let currentData = data;
        this.recursivelyUpdateTheNodes(currentData, selectedParentNode, members);

        this.setState({ iterator: iterator, membersPage: membersPage });
        return currentData;
    };
    loadSegmentsAsync = async (nodeToExpand) => {
        // Get variables from state
        let iterator = this.state.iterator;
        let connectionId = this.state.connectionId;
        let allConnectionIds = this.state.allConnectionIds;
        let alias = this.state.dataSource;
        let dimensionName = this.state.dimensionAlias;
        let connectionName = this.state.connectionName;
        let data = this.state.treeData;
        let selections = this.state.selections;

        // Get The API To Get The Segments
        let getSegmentsResponse = await getConnectionSegments(connectionId, allConnectionIds, alias, dimensionName, connectionName);

        // Process Response
        let segments = [];
        let dimension = getSegmentsResponse.dimension;

        // Update The New Tree View
        dimension.segments.forEach(d => {
            let newNode = {
                id: iterator,
                name: `Segment ${d.alias}`,
                isExpanded: false,
                isChecked: false,
                isExpandable: true,
                isCheckable: false,
                lastChanged: null,
                children: [
                    MembersTreeViewNodeHelper.GetSegmentMembersNode(d, dimension, (iterator + 1), MembersTreeViewNodeHelper.IsThisSegmentMemberNodePartOfTheSelections(selections, d)),
                    MembersTreeViewNodeHelper.GetSegmentRollupNode(d, dimension, (iterator + 2), MembersTreeViewNodeHelper.IsThisSegmentRollupNodePartOfTheSelections(selections, d)),
                    MembersTreeViewNodeHelper.GetSegmentMembersSuperNode(d, dimension, (iterator + 3), nodeToExpand)
                ],
                value: {}
            };

            segments.push(newNode);
            iterator = iterator + 4;
        });

        let currentData = data;
        this.recursivelyUpdateTheNodes(currentData, nodeToExpand, segments);

        this.setState({ iterator: iterator });
        return currentData;
    };
    loadSegmentMembersAsync = async (nodeToExpand) => {
        // Get variables from state
        let iterator = this.state.iterator;
        let connectionId = this.state.connectionId;
        let allConnectionIds = this.state.allConnectionIds;
        let alias = this.state.dataSource;
        let dimensionName = this.state.dimensionAlias;
        let data = this.state.treeData;
        let segmentParent = nodeToExpand.value.valueAlias;
        let selections = this.state.selections;
        let connectionName = this.state.connectionName;
        let multiSegmentAlias = [];
        let multiSegmentMembers = [];

        // Filter specific segment types of the node we opened contains such definitions
        if (nodeToExpand.value.nodeSegments !== undefined && nodeToExpand.value.nodeSegmentsMembers !== undefined) {
            multiSegmentAlias = nodeToExpand.value.nodeSegments;
            multiSegmentMembers = nodeToExpand.value.nodeSegmentsMembers;
        }

        // Call The API To Get Segment Members
        let response = await getSegmentMembers(connectionId, allConnectionIds, alias, dimensionName, segmentParent, multiSegmentAlias, multiSegmentMembers, connectionName);

        // Process Response
        let members = [];
        let dimension = response.dimension;
        let segment = { alias: "", systemName: "" };
        let needNextLevelMultiSegmentNode = false;
        let getSegmentsResponse = {
            "dimension": {}
        };
        let dimensionInfo = {};
        let multiSegmentData = {
            "currentSegment": {},
            "segments": [],
            "copiedSegments": []
        };

        if (dimension.segments.length > 0) {
            segment = dimension.segments[0];
        }

        // If we are coming into this from a Multi Segment Selection
        let expandedNodeWAsMultiSegment = (nodeToExpand.value.nodeSegments !== undefined
            && nodeToExpand.value.segmentLevel !== undefined
            && nodeToExpand.value.nodeSegmentsMembers !== undefined);
        if (expandedNodeWAsMultiSegment) {
            if (nodeToExpand.value.nodeSegments.length > nodeToExpand.value.segmentLevel) {
                // Get The API To Get The Segments
                getSegmentsResponse = await getConnectionSegments(connectionId, allConnectionIds, alias, dimensionName, connectionName);
                dimensionInfo = getSegmentsResponse.dimension;
                multiSegmentData = this.getMultiSegmentData(dimensionInfo, nodeToExpand);
                needNextLevelMultiSegmentNode = true;
            }
        }

        // Go through each member and add the nodes
        dimension.members.forEach(d => {
            let membersSegmentSelected = MembersTreeViewNodeHelper.IsThisMemberSegmentDimensionPartOfTheSelections(selections, d, segment);
            let segmentRollupSelected = MembersTreeViewNodeHelper.IsThisRollupSegmentDimensionPartOfTheSelections(selections, d, segment);

            let nodeChildren = [
                MembersTreeViewNodeHelper.GetSegmentValueMembersNode(segment, d, dimension, iterator, membersSegmentSelected),
                MembersTreeViewNodeHelper.GetSegmentValueRollupNode(segment, d, dimension, (iterator + 1), segmentRollupSelected),
                MembersTreeViewNodeHelper.GetSegmentValueMembersSuperNode(segment, d, dimension, (iterator + 2), nodeToExpand)
            ];
            iterator = iterator + 3;

            // We entered this through a multi segment selection, so therefore we need to get information over the next segment
            if (needNextLevelMultiSegmentNode) {
                let multiSegmentNodeMembersNode = MembersTreeViewNodeHelper.GetMultiSegmentMembersNode(dimensionInfo, nodeToExpand, d, multiSegmentData["currentSegment"], selections, iterator);
                iterator++;
                nodeChildren.push(multiSegmentNodeMembersNode);

                let multiSegmentNodeRollupNode = MembersTreeViewNodeHelper.GetMultiSegmentRollupNode(dimensionInfo, nodeToExpand, d, multiSegmentData["currentSegment"], selections, iterator);
                iterator++;
                nodeChildren.push(multiSegmentNodeRollupNode);

                let nextLevelMultiSegmentNode = MembersTreeViewNodeHelper.GetSegmentMembersSuperNode(multiSegmentData["currentSegment"], dimensionInfo, iterator, nodeToExpand, multiSegmentData["currentSegment"]["alias"], d.alias, d.systemName);
                iterator++;
                nodeChildren.push(nextLevelMultiSegmentNode);
            } else if (multiSegmentData["currentSegment"]["alias"] === undefined && !needNextLevelMultiSegmentNode && expandedNodeWAsMultiSegment) {
                // Special case, we have reached the end of the multi level segment node structre and we need the final Members and Rollup nodes
                let multiSegmentNodeMembersNode = MembersTreeViewNodeHelper.GetMultiSegmentMembersNodeLastSegment(dimension, nodeToExpand, d, { "alias": nodeToExpand["value"]["valueAlias"], "systemName": nodeToExpand["value"]["valueSystemName"] }, selections, iterator);
                iterator++;
                nodeChildren.push(multiSegmentNodeMembersNode);

                let multiSegmentNodeRollupNode = MembersTreeViewNodeHelper.GetMultiSegmentRollupNodeLastSegment(dimension, nodeToExpand, d, selections, iterator);
                iterator++;
                nodeChildren.push(multiSegmentNodeRollupNode);
            }

            let newNode = {
                id: iterator,
                name: `Member ${d.alias}`,
                isExpanded: false,
                isChecked: false,
                isExpandable: true,
                isCheckable: false,
                lastChanged: null,
                children: nodeChildren,
                value: {
                    caption: `Member ${d.alias}`,
                    dimensionAlias: dimension.alias,
                    dimensionSystemName: dimension.systemName,
                    valueAlias: d.alias,
                    valueSystemName: d.systemName,
                    member: true,
                    segment: false,
                    parentName: dimension.alias,
                    parentType: 0
                },
            };
            
            members.push(newNode);
            iterator = iterator + 1;
        });

        // Set the new data
        let currentData = data;
        this.recursivelyUpdateTheNodes(currentData, nodeToExpand, members);

        this.setState({ iterator: iterator });
        return currentData;
    };
    loadSegmentLowerLevelMembers = async (nodeToExpand) => {
        // Get variables from state
        let iterator = this.state.iterator;
        let connectionId = this.state.connectionId;
        let allConnectionIds = this.state.allConnectionIds;
        let alias = this.state.dataSource;
        let dimensionName = this.state.dimensionAlias;
        let data = this.state.treeData;
        let selections = this.state.selections;
        let connectionName = this.state.connectionName;
        let segmentParent = nodeToExpand.value.parentName;
        let segmentChild = nodeToExpand.value.valueSystemName;
        let multiSegmentAlias = [];
        let multiSegmentMembers = [];

        // Filter specific segment types of the node we opened contains such definitions
        if (nodeToExpand.value.nodeSegments !== undefined && nodeToExpand.value.nodeSegmentsMembers !== undefined) {
            multiSegmentAlias = nodeToExpand.value.nodeSegments;
            multiSegmentMembers = nodeToExpand.value.nodeSegmentsMembers;
        }

        // Call API To Get Members Within A Segment Memer
        let response = await getMembersWithinSegment(connectionId, allConnectionIds, alias, dimensionName, segmentParent, segmentChild, multiSegmentAlias, multiSegmentMembers, connectionName);

        // Process Response
        let members = [];
        let dimension = response.dimension;

        dimension.members.forEach(d => {
            members.push(
                MembersTreeViewNodeHelper.GetIndividualMemberTreeViewNode(
                    d,
                    dimension,
                    iterator,
                    MembersTreeViewNodeHelper.IsThisMemberDimensionPartOfTheSelections(selections, d)
                )
            );

            iterator++;
        });

        // Set the new data
        let currentData = data;
        this.recursivelyUpdateTheNodes(currentData, nodeToExpand, members);

        this.setState({ iterator: iterator });
        return currentData;
    };
    loadFirstMultiSegmentLayer = async (nodeToExpand) => {
        // Get variables from state
        let iterator = this.state.iterator;
        let connectionId = this.state.connectionId;
        let allConnectionIds = this.state.allConnectionIds;
        let alias = this.state.dataSource;
        let dimensionName = this.state.dimensionAlias;
        let connectionName = this.state.connectionName;
        let data = this.state.treeData;
        let selections = this.state.selections;

        // Get The API To Get The Segments
        let getSegmentsResponse = await getConnectionSegments(connectionId, allConnectionIds, alias, dimensionName, connectionName);
        let dimension = getSegmentsResponse.dimension;

        // Process Which Segments From This Server Call Are Included
        let multiSegmentData = this.getMultiSegmentData(dimension, nodeToExpand);

        // Build New Nodes
        let childNodes = [];
        childNodes.push(MembersTreeViewNodeHelper.GetSegmentMembersNode(multiSegmentData["currentSegment"], dimension, iterator));
        iterator++;

        childNodes.push(MembersTreeViewNodeHelper.GetSegmentRollupNode(multiSegmentData["currentSegment"], dimension, iterator));
        iterator++;

        // Go backwards on segment and pop the copied array until we only have one item
        for (let i = 0; i < (multiSegmentData.segments.length - 1); i++) {
            childNodes.push(MembersTreeViewNodeHelper.GetFirstLevelMultiSegmentMembersNode(multiSegmentData["copiedSegments"], dimension, selections, iterator));
            iterator++;
            childNodes.push(MembersTreeViewNodeHelper.GetFirstLevelMultiSegmentRollupNode(multiSegmentData["copiedSegments"], dimension, selections, iterator));
            iterator++;
            multiSegmentData.copiedSegments.pop();
        }

        childNodes.push(MembersTreeViewNodeHelper.GetSegmentMembersSuperNode(multiSegmentData["currentSegment"], dimension, iterator, nodeToExpand, multiSegmentData["currentSegment"]["alias"]));
        iterator++;

        // Process New Tree View
        let currentData = data;
        this.recursivelyUpdateTheNodes(currentData, nodeToExpand, childNodes);

        // And Finally....
        this.setState({ iterator: iterator });
        return currentData;
    };
    //#endregion

    //#region Update Tree Data
    updateTreeData = (updatedData, isMultiSelect) => {
        if (isMultiSelect === false) {
            let latestDate = null;
            latestDate = this.getLatestUpdatedData(updatedData, latestDate);

            if (latestDate !== null) {
                this.recursivelyUncheckAllNodesExceptNewSelected(updatedData, latestDate);
            }
        }

        this.setState({ treeData: updatedData });
    };
    getLatestUpdatedData = (updatedData, currentDate) => {
        let rtnVal = currentDate;

        updatedData.forEach(data => {
            if (data.lastChanged !== null) {
                if (rtnVal === null) {
                    rtnVal = data.lastChanged;
                } else if (data.lastChanged > rtnVal) {
                    rtnVal = data.lastChanged;
                }
            }

            if (data.children !== null) {
                rtnVal = this.getLatestUpdatedData(data.children, rtnVal);
            }
        });

        return rtnVal;
    };
    recursivelyUpdateTheNodes = (updatedData, nodeToExpand, newChildren) => {
        updatedData.forEach(data => {
            if (data.id === nodeToExpand.id) {
                data.isChildrenLoading = false;
                data.isExpanded = true;

                if (data.children === null || data.children === undefined) {
                    data.children = newChildren;
                } else {
                    data.children = data.children.concat(newChildren);
                }
            } else if (data.children !== null) {
                this.recursivelyUpdateTheNodes(data.children, nodeToExpand, newChildren);
            }
        });
    };
    recursivelyUncheckAllNodesExceptNewSelected = (updatedData, latestDate) => {
        updatedData.forEach(data => {
            if (data.lastChanged === null) {
                data.isChecked = false;
            }

            if (latestDate !== null && data.lastChanged === latestDate) {
                data.isChecked = true;
            } else {
                data.isChecked = false;
            }

            if (data.children !== null) {
                this.recursivelyUncheckAllNodesExceptNewSelected(data.children, latestDate);
            }
        });
    };
    recursivelyLookupNewChecked = (treeData, selected) => {
        treeData.forEach(data => {
            data["isChecked"] = false;

            // If the item is still in the selections, we re-check it
            selected.forEach(s => {
                if (data["name"] === s["caption"]) {
                    data["isChecked"] = true;
                }
            });

            if (data["children"] !== null) { this.recursivelyLookupNewChecked(data["children"], selected); }
        });
    };
    //#endregion

    //#region Processing Data
    getSelectionDataFromNodeValue = (nodeValue) => {
        let rtnVal = {
            caption: nodeValue.caption,
            dimensionAlias: nodeValue.dimensionAlias,
            dimensionSystemName: nodeValue.dimensionSystemName,
            valueAlias: nodeValue.valueAlias,
            valueSystemName: nodeValue.valueSystemName,
            filter: null,
            isSelected: true,
            isMissing: false
        };

        // Add to the item if its a member or a segment
        if (nodeValue.globalSet) {
            rtnVal["globalParameter"] = nodeValue.globalParameter
            rtnVal["globalSet"] = nodeValue.globalSet
        } else if (nodeValue.member) {
            rtnVal["parentName"] = nodeValue.parentName
            rtnVal["parentType"] = nodeValue.parentType
        } else if (nodeValue.segment) {
            rtnVal["segmentAlias"] = nodeValue.segmentAlias;
            rtnVal["segmentSystemName"] = nodeValue.segmentSystemName;
        } else if (nodeValue.multiSegment) {
            rtnVal["segmentSelections"] = nodeValue.segmentSelections;
            rtnVal["segmentCombination"] = nodeValue.segmentCombination;
        } else if (nodeValue.selectionObjectName) {
            rtnVal["selectionObjectName"] = nodeValue.selectionObjectName;
        }

        // Add to list
        return rtnVal;
    };
    getAllCurrentlyLoadedItems = (data) => {
        let rtnVal = [];

        if (data.length > 1) {
            let membersNode = data[0];

            if (membersNode.children !== null) {
                membersNode.children.forEach(child => {
                    rtnVal.push(child.value.valueSystemName);
                });
            }
        }

        return rtnVal;
    };
    getMultiSegmentData = (dimension, node) => {
        let includedSegments = node.value.nodeSegments;
        let rtnVal = {
            "previousSegment": "",
            "currentSegment": {},
            "segments": [],
            "copiedSegments": []
        };

        for (let includedIterator = 0; includedIterator < includedSegments.length; includedIterator++) {
            if (includedIterator >= node.value.segmentLevel) {
                dimension.segments.forEach(segment => {
                    if (includedSegments[includedIterator] === segment.alias) {
                        rtnVal.segments.push(segment);
                        rtnVal.copiedSegments.push(segment);

                        if (includedIterator === node.value.segmentLevel) {
                            rtnVal["currentSegment"] = segment;

                            if (includedIterator > 0) {
                                rtnVal["previousSegment"] = includedSegments[includedIterator - 1];
                            }
                        }
                    }
                });
            }
        }

        return rtnVal;
    };
    removeSpecificItemFromCollection = (nodeValue, selections) => {
        let rtnVal = [];

        selections.forEach(s => {
            let isTheSame = true;

            if (nodeValue.member && nodeValue.parentName !== s.parentName) isTheSame = false;
            if (nodeValue.member && nodeValue.parentType !== s.parentType) isTheSame = false;
            if (nodeValue.segment && nodeValue.segmentAlias !== s.segmentAlias) isTheSame = false;
            if (nodeValue.segment && nodeValue.segmentSystemName !== s.segmentSystemName) isTheSame = false;
            if (nodeValue.caption !== s.caption) isTheSame = false;
            if (nodeValue.dimensionAlias !== s.dimensionAlias) isTheSame = false;
            if (nodeValue.valueAlias !== s.valueAlias) isTheSame = false;
            if (nodeValue.valueSystemName !== s.valueSystemName) isTheSame = false;
            if (nodeValue.selectionObjectName && nodeValue.selectionObjectName !== s.selectionObjectName) isTheSame = false;

            if (!isTheSame) {
                rtnVal.push(s);
            }
        });

        return rtnVal;
    };
    setInitialTreeView = (selections, addedMultiSegmentSelections, quickPicksTag, dataSource, connectionName, globals, dimensionAlias) => {
        let rtnVal = [];

        if (!IsThisConnectionPowerBi(connectionName)) {
            rtnVal.push({
                "id": -1,
                "name": "Members",
                "isExpanded": false,
                "isChecked": false,
                "isExpandable": true,
                "isCheckable": false,
                "value": {},
                "lastChanged": null,
                "children": null
            });
            rtnVal.push({
                "id": -2,
                "name": "Segments",
                "isExpanded": false,
                "isChecked": false,
                "isExpandable": true,
                "isCheckable": false,
                "value": {},
                "lastChanged": null,
                "children": null
            });
        }

        // We need to go through the selections to see if a multi segment selection has been done
        if (DoTheseSelectionsHaveMultiSegments(selections) || addedMultiSegmentSelections.length > 0) {
            // Add Multi Segment Selections
            let fromExistingSelections = MembersTreeViewNodeHelper.GetHighestLevelMultiSegmentNodes(selections, 0)
            let added = MembersTreeViewNodeHelper.GetAddedLevelMultiSegmentNodes(addedMultiSegmentSelections)

            rtnVal.push({
                "id": -3,
                "name": "Multiple Segment Selections",
                "isExpanded": false,
                "isChecked": false,
                "isExpandable": true,
                "isCheckable": false,
                "value": {},
                "lastChanged": null,
                "children": fromExistingSelections.concat(added)
            })
        }

        // Quick Picks
        if (quickPicksTag.dimensionAlias) {
            let dataSourceToUse = dataSource
            if (IsThisConnectionPowerBi(connectionName)) { dataSourceToUse = "DATA"; }
            rtnVal.push({
                "id": -4,
                "name": "Quick Picks Selections",
                "isExpanded": false,
                "isChecked": false,
                "isExpandable": true,
                "isCheckable": false,
                "value": {},
                "lastChanged": null,
                "children": MembersTreeViewNodeHelper.GetAllQuickPicksSelections(selections, quickPicksTag, dataSourceToUse)
            })
        }

        // Globals Selection
        if (globals && globals.length > 0) {
            let dataSourceToUse = dataSource
            let childNodes = MembersTreeViewNodeHelper.GetAllGlobalsSelections(selections, globals, dataSourceToUse, dimensionAlias)
            if (childNodes.length > 0) {
                rtnVal.push({
                    "id": -5,
                    "name": "Globals",
                    "isExpanded": false,
                    "isChecked": false,
                    "isExpandable": true,
                    "isCheckable": false,
                    "value": {},
                    "lastChanged": null,
                    "children": childNodes
                })
            }
        }

        return rtnVal;
    };
    //#endregion

    //#region Event Handlers
    handleSearchTermChange = (event) => {
        // TODO: look at a way to expand searching to hit the API end point
        this.setState({ searchTerm: event.target.value }, () => {
            // POST SET STATE CODE RUNS HERE
        });
    };
    //#endregion
}